import {Pipe, PipeTransform} from '@angular/core';
import {Pick} from '../core/pick';

@Pipe({name: 'nonQualifyingDeaths'})
export class NonQualifiedDeathPipe implements PipeTransform{

    transform(picks: Pick[]) {
        return picks.filter(pick => !pick.qualifiedDeath);
    }
}



// WEBPACK FOOTER //
// /Users/william/Documents/gitlab/stovokor/src/app/pipe/non-qualified-death.pipe.ts